import * as React from 'react';
import { Text, View } from 'react-native';

const PublisherBanner = () => (
  <View>
    <Text>PublisherBanner component not supported on the web</Text>
  </View>
);

export default PublisherBanner;
